import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InvoiceView } from "generated/graphql";
import { USER_LOGOUT } from "redux/system.action";
import RequestStatus from "../RequestStatus";
import { createInvoice, fetchInvoices, updateInvoice } from "./invoice.action";

export type Invoice = Omit<InvoiceView, "__typename" | "clientId" | "payload" | "meta">;

export interface InvoiceState {
  status: RequestStatus;
  invoices: Invoice[];
}

const initialState: InvoiceState = {
  status: RequestStatus.IDLE,
  invoices: [],
};

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    updateInvoiceEntryCount(state, action: PayloadAction<{ invoiceId: number; entryCount: number }>) {
      const foundInvoice = state.invoices.find((i) => i.id === action.payload.invoiceId);

      if (foundInvoice) {
        foundInvoice.entryCount += action.payload.entryCount;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.pending, (state) => {
        state.status = RequestStatus.PENDING;
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.status = RequestStatus.SUCCEEDED;
        state.invoices = action.payload;
      })
      .addCase(fetchInvoices.rejected, (state) => {
        state.status = RequestStatus.FAILED;
      });
    builder.addCase(createInvoice.fulfilled, (state, action) => {
      state.invoices.unshift(action.payload);
    });
    builder.addCase(updateInvoice.fulfilled, (state, action) => {
      const foundIndex = state.invoices.findIndex((i) => i.id === action.payload.id);
      const invoice = state.invoices[foundIndex];

      if (foundIndex !== -1 && invoice !== undefined) {
        state.invoices[foundIndex] = {
          entryCount: invoice.entryCount,
          ...action.payload,
        };
      }
    });
    builder.addCase(USER_LOGOUT, () => {
      return { ...initialState };
    });
  },
});

export const { updateInvoiceEntryCount } = invoiceSlice.actions;
export default invoiceSlice;
